import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import RadioDefault from "../../components/radioGroup";
import Table from "../../components/table";
import DropDown from '../../components/dropdown'
import RadioButton from '../../components/radio';
import FormHead from '../../components/headings/FromHead';
import Fields from "../../components/field/freeField";
import { Error } from "@progress/kendo-react-labels";
import { useNavigate } from "react-router-dom";
import { FormInput } from "../../wrappers/formInput";
import classnames from "classnames"; 
import Styles from "./styles.module.scss";
import { Icon } from '@iconify/react';
import UploadHolidayList from "../../modal/uploadHolidayList";

export type TimesheetSettingsForm = {
  approvalNeeded: number;
  paidLeave: number;
  paidLeaveCount: number;
  leavesCarryForward: number;
  payPeriod: string;
  leaveNumber: string;
  companyPaidLeaveAllowed: number;
  companyPaidLeaveCount: number;
  companyCarryForwardAllowed: number;
  companyCarryForwardLeaveCount: number;
  billingType: number;
  companyPaidHolidayAllowed: any
}

interface props {
  clickHandler: any;
  defaultValues: any;
  holidayList: any;
  uploadList: any;
}

const TimesheetSettings = (props: props) => {
  
  const navigate = useNavigate()
  const[showModal, setShowModal] = useState<boolean>(false)
  const [approvalNeeded, setApprovalNeeded] = useState<number>();
  const [paidLeave, setPaidLeave] = useState<number>(0)
  const [billingType, setBillingType] = useState<number>(0)
  const [carryForward, setCarryForward] = useState<number>(1) 
  const [companyPaidLeaveAllowed, setCompanyPaidLeaveAllowed] = useState<number>(0)
  const [companyCarryForwardAllowed, setCompanyCarryForwardAllowed] = useState<number>(1)
  const [companyCarryForwardLeaveCount , setCompanyCarryForwardLeaveCount] = useState<any>()
  const [companyPaidHolidayAllowed, setCompanyPaidHolidayAllowed] = useState<number>();
  const [error, setError] = useState<{ approvalNeeded?: string, paidLeave?: string, paidLeaveCount?: string, companyPaidLeaveAllowed?: string, leavesCarryForward?: string, payPeriod?: string, leaveNumber?: string, companyPaidLeaveCount?: string, companyCarryForwardAllowed?: string, companyCarryForwardLeaveCount?: string, billingType?: string, companyPaidHolidayAllowed?: string}>({
        approvalNeeded: '', paidLeave: '', paidLeaveCount: '',  leaveNumber: '', companyPaidLeaveAllowed: '',  leavesCarryForward: '', payPeriod:'', companyPaidLeaveCount:'',  companyCarryForwardAllowed: '',  companyCarryForwardLeaveCount: '', billingType: '', companyPaidHolidayAllowed: ''})
  const formOptions = {};

  const { register, handleSubmit, control, reset, setValue, formState } = useForm<TimesheetSettingsForm>(formOptions);

  useEffect(() => {
    
    if (props.defaultValues) {
      if (props.defaultValues.approvalNeeded || props.defaultValues.approvalNeeded === false) {
        setApprovalNeeded(props.defaultValues.approvalNeeded === false ? 1 : 0)
        setValue("approvalNeeded", props.defaultValues.approvalNeeded === false ? 1 : 0);
      }
      if (props.defaultValues.companyPaidLeaveAllowed || props.defaultValues.companyPaidLeaveAllowed === false) {
        setCompanyPaidLeaveAllowed(props.defaultValues.companyPaidLeaveAllowed  === false ? 1 : 0)
        setValue("companyPaidLeaveAllowed",props.defaultValues.companyPaidLeaveAllowed  === false ? 1 : 0)
        setValue("companyPaidLeaveCount",props.defaultValues.companyPaidLeaveAllowed === true && props.defaultValues.companyPaidLeaveCount ? props.defaultValues.companyPaidLeaveCount: 1)
      }
      if (props.defaultValues.companyPaidHolidayAllowed || props.defaultValues.companyPaidHolidayAllowed === false) {
        setCompanyPaidHolidayAllowed(props.defaultValues.companyPaidHolidayAllowed === false ? 1 : 0)
        setValue("companyPaidHolidayAllowed", props.defaultValues.companyPaidHolidayAllowed === false ? 1 : 0);
      }
      if (props.defaultValues.companyCarryForwardAllowed || props.defaultValues.companyCarryForwardAllowed === false) {
        setCompanyCarryForwardAllowed(props.defaultValues.companyCarryForwardAllowed === false ? 1 : 0)
        setValue("companyCarryForwardAllowed",props.defaultValues.companyCarryForwardAllowed === false ? 1 : 0)
        setCompanyCarryForwardLeaveCount(props.defaultValues.companyCarryForwardLeaveCount)
        setValue("companyCarryForwardLeaveCount",props.defaultValues.companyCarryForwardAllowed === true && props.defaultValues.companyCarryForwardLeaveCount? props.defaultValues.companyCarryForwardLeaveCount: 1)
      }
      if (props.defaultValues.paidLeaveAllowed || props.defaultValues.paidLeaveAllowed === false) {
        setPaidLeave(props.defaultValues.paidLeaveAllowed === false ? 1 : 0)
        setValue("paidLeave", props.defaultValues.paidLeaveAllowed === false ? 1 : 0)
        setValue("paidLeaveCount", props.defaultValues.paidLeaveAllowed === true && props.defaultValues.paidLeaveCount ? props.defaultValues.paidLeaveCount : 1)
      }
      if (props.defaultValues.carryForwardAllowed || props.defaultValues.carryForwardAllowed === false) {
        setCarryForward(props.defaultValues.carryForwardAllowed === false ? 1 : 0)
        setValue("leavesCarryForward", props.defaultValues.carryForwardAllowed === false ? 1 : 0)
        setValue("leaveNumber",props.defaultValues.carryForwardAllowed === true && props.defaultValues.carryForwardLeaveCount ? props.defaultValues.carryForwardLeaveCount : 1)    
      }
      if(props.defaultValues.billingType){
        if(props.defaultValues.billingType === "Type1"){
          setBillingType(0)
        }else{
          setBillingType(1)
        }
      }
      if (props.defaultValues.payPeriod) {
        setValue('payPeriod', props.defaultValues.payPeriod)
      }
    }
 
  }, [props.defaultValues])
  
  
  const onSubmit = (data: any) => {
    
    let hasError: boolean = false;
    // if (data.leavesCarryForward === 0 && !data.leaveNumber) {
    //   setValue('leaveNumber', '1')
    // }
    if (!data.leavesCarryForward && data.leavesCarryForward !== 0) {
      data.leavesCarryForward = 0;
      setValue('leavesCarryForward', 0)
    }
    if (!data.approvalNeeded && data.approvalNeeded !== 0) {
      error.approvalNeeded = 'Field is required'
      hasError = true;
      setError({ ...error });
    }
    if (data.companyPaidLeaveAllowed === 0 && data.companyPaidLeaveCount === "") {   
      error.companyPaidLeaveCount  = 'Field is required'
      hasError = true;
      setError({ ...error });
    }
    if (!data.companyPaidHolidayAllowed && data.companyPaidHolidayAllowed !== 0) {
      error.companyPaidHolidayAllowed = 'Field is required'
      hasError = true;
      setError({ ...error });
    }
    if (data.companyCarryForwardAllowed === 0 && data.companyCarryForwardLeaveCount === "") {   
      error.companyCarryForwardLeaveCount  = 'Field is required'
      hasError = true;
      setError({ ...error });
    }
    if (data.paidLeave === 0 && data.paidLeaveCount === "") {   
      error.paidLeaveCount  = 'Field is required'
      hasError = true;
      setError({ ...error });
    }
    if (data.leavesCarryForward === 0 && data.leaveNumber === "") {   
      error.leaveNumber  = 'Field is required'
      hasError = true;
      setError({ ...error });
    }

    if (!data.paidLeave && data.paidLeave !== 0) {
      data.paidLeave = 0;
      setValue('paidLeave', 0);
    }
    if (!data.payPeriod) {
      data.payPeriod = 'Monthly';
      setValue('payPeriod', 'Monthly');
    }
    if (!hasError) {
      props.clickHandler(data)
    }
  }

  const onChange = (e: any, name: string) => {
    
    if (name === "approvalNeeded") {
      setApprovalNeeded(e.value)
      setValue("approvalNeeded", e.value)
      error.approvalNeeded = ''
      setError({...error})
    }
    if (name === 'companyPaidLeaveAllowed') {
      setCompanyPaidLeaveAllowed(e.value)
      setValue('companyPaidLeaveAllowed', e.value)
      delete error.companyPaidLeaveCount 
      setError({...error})
    }
    if (name === 'companyPaidLeaveCount') {
      setValue('companyPaidLeaveCount', e.target.value)  
      delete error.companyPaidLeaveCount 
      setError({...error})
    }
    if (name === "companyPaidHolidayAllowed") {
      setCompanyPaidHolidayAllowed(e.value)
      setValue("companyPaidHolidayAllowed", e.value)
      error.companyPaidHolidayAllowed = ''
      setError({...error})
    }
    if (name === 'companyCarryForwardAllowed') {
      setCompanyCarryForwardAllowed(e.value)
      setValue('companyCarryForwardAllowed', e.value)
      delete error.companyCarryForwardAllowed 
      delete error.companyCarryForwardLeaveCount
      setError({...error})
    }
    if (name === 'companyCarryForwardLeaveCount') {
      setValue('companyCarryForwardLeaveCount', e.target.value)  
      delete error.companyCarryForwardLeaveCount
      setError({...error})
    }
    if (name === 'paidLeave') {
      setPaidLeave(e.value)
      setValue('paidLeave', e.value)
      delete error.paidLeave 
      delete error.paidLeaveCount 
      setError({...error})
    }
    if (name === 'paidLeaveCount') {
      setValue('paidLeaveCount', e.target.value)
      delete error.paidLeaveCount 
      setError({...error})
    }
    if (name === 'leavesCarryForward') {
      setCarryForward(e.value)
      setValue('leavesCarryForward', e.value)
      delete error.leavesCarryForward 
      delete error.leaveNumber 
      setError({...error})
    }
    if (name === 'leaveNumber') {
      setValue('leaveNumber', e.target.value)  
      delete error.leaveNumber 
      setError({...error})
    }
    if (name === 'payPeriod') {
      setValue('payPeriod', e.value)
      delete error.payPeriod 
      setError({...error})  
    }
    if (name === 'billingType') {
      setValue('billingType', e.value)
      setBillingType(e.value)
      delete error.billingType 
      setError({...error})  
    }
  }
  return (
    <>
      <section className="contentBox">
        <div className="innerPadd24">
          {showModal && <UploadHolidayList onClose={() => setShowModal(false)} clickHandler={(file: any) => { props.uploadList(file); setShowModal(false) }} />}
      <form>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormHead>Is the timesheet approval needed ?</FormHead>
            <RadioDefault
              name="approvalNeeded"
              layout={"vertical"}
              data={[{ label: "Yes", value: 0 }, { label: "No", value: 1 }]}
              checked={approvalNeeded}
              handleChange={(e: any) => onChange(e, "approvalNeeded")}
            />
            <Error>{error.approvalNeeded}</Error>
          </div>
          <div className={classnames(Styles.payPeriod, "form-group")}>
                <label className="lablel">Pay Period</label>
                {console.log(props.defaultValues)}
            <DropDown
              name="payPeriod"
              data={["Monthly", "Weekly", "Bi-Weekly"]}
              defaultValue={props?.defaultValues?.payPeriod ? props?.defaultValues?.payPeriod : 'Monthly'}
              onChange={(e: any) => onChange(e, 'payPeriod')}
            />
          </div>
        </div>
        <div className="form-group">
          <FormHead> Does company allows candidate to take paid leaves ? </FormHead>
          <div className={Styles.companyInput}>
            <RadioButton
              name="companyPaidLeaveAllowed"
              handleChange={(e: any) => onChange(e, 'companyPaidLeaveAllowed')}
              label='Yes'
              value={0}
              checked={companyPaidLeaveAllowed === 0}
            /> 
            { companyPaidLeaveAllowed === 0 && 
              <div className={Styles.input}>
                <FormInput<TimesheetSettingsForm>
                  name="companyPaidLeaveCount"
                  placeholder="Enter number of leaves"
                  onchange={(e: any) => onChange(e, 'companyPaidLeaveCount')}
                  type='number'
                  register={register}
                />
              </div>
            }
            <Error>{error.companyPaidLeaveCount}</Error>
          </div>
          <br></br>
          <RadioButton
            name="companyPaidLeaveAllowed"
            handleChange={(e: any) => onChange(e, 'companyPaidLeaveAllowed')}
            label='No'
            value={1}
            checked={companyPaidLeaveAllowed === 1}
          />
          <Error>{error.companyPaidLeaveAllowed}</Error>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <FormHead>Does company allows candidate to take Paid Holidays ?</FormHead>
            <RadioDefault
              name="companyPaidHolidayAllowed"
              layout={"vertical"}
              data={[{ label: "Yes", value: 0 }, { label: "No", value: 1 }]}
              checked={companyPaidHolidayAllowed}
              handleChange={(e: any) => onChange(e, "companyPaidHolidayAllowed")}
            />
            <Error>{error.companyPaidHolidayAllowed}</Error>
          </div>
        </div>
        <div className="form-group">
          <FormHead> Does the company allows  carry forward leaves? </FormHead>
          <div className={Styles.companyInput}>
            <RadioButton
              name="companyCarryForwardAllowed"
              handleChange= {(e: any) => onChange(e, 'companyCarryForwardAllowed')}
              label='Yes'
              value={0}
              checked={companyCarryForwardAllowed === 0}
            /> 
            { companyCarryForwardAllowed === 0 && 
              <div className={Styles.input}>
                <FormInput<TimesheetSettingsForm>
                  name="companyCarryForwardLeaveCount"
                  placeholder="Enter number of leaves"
                  onchange={(e: any) => onChange(e, 'companyCarryForwardLeaveCount')}
                  type='number'
                  register={register}
                />
              </div>
            }
            <Error>{error.companyCarryForwardLeaveCount}</Error>
          </div>
          <br></br>
          <RadioButton
            name="companyCarryForwardAllowed"
            handleChange={(e: any) => onChange(e, 'companyCarryForwardAllowed')}
            label='No'
            value={1}
            checked={companyCarryForwardAllowed === 1}
          />
          <Error>{error.companyCarryForwardAllowed}</Error>
        </div>
        <div className="form-group">
          <FormHead>
            Does ellow allows the candidate to take one paid leave everymonth ?
          </FormHead>
          <div className={Styles.companyInput}>
            <RadioButton
              name="paidLeave"
              handleChange={(e: any) => onChange(e, 'paidLeave')}
              label='Yes'
              value={0}
              checked={paidLeave === 0}
            /> 
            { paidLeave === 0 && 
              <div className={Styles.input}>
                <FormInput<TimesheetSettingsForm>
                  name="paidLeaveCount"
                  placeholder="Enter number of leaves"
                  onchange={(e: any) => onChange(e, 'paidLeaveCount')}
                  type='number'
                  register={register}
                />
              </div>
            }
            <Error>{error.paidLeaveCount}</Error>
          </div>
          <br></br>
          <RadioButton
            name="paidLeave"
            handleChange={(e: any) => onChange(e, 'paidLeave')}
            label='No'
            value={1}
            checked={paidLeave === 1}
          />
          <Error>{error.paidLeave}</Error>
        </div>
        <div className="form-group">
          <FormHead>
            Does ellow allows carry forward leaves ?
          </FormHead>
          <div className={Styles.companyInput}>
            <RadioButton
              name="leavesCarryForward"
              handleChange={(e: any) => onChange(e, 'leavesCarryForward')}
              label='Yes'
              value={0}
              checked={ carryForward === 0}
            /> 
            { carryForward === 0 && 
              <div className={Styles.input}>
                <FormInput<TimesheetSettingsForm>
                  name="leaveNumber"
                  placeholder="Enter number of leaves"
                  onchange={(e: any) => onChange(e, 'leaveNumber')}
                  type='number'
                  register={register}
                  // defaultValue={props.defaultValues && props.defaultValues.carryForwardAllowed === true && props.defaultValues.carryForwardLeaveCount ? props.defaultValues.carryForwardLeaveCount : 1}
                />
              </div>
            }
            <Error>{error.leaveNumber}</Error>
          </div>
          <br></br>
          <RadioButton
            name="leavesCarryForward"
            handleChange={(e: any) => onChange(e, 'leavesCarryForward')}
            label='No'
            value={1}
            checked={ carryForward === 1}
          />
          <Error>{error.leavesCarryForward}</Error>
        </div>
        <div className="form-group">
          <FormHead>What is the customer billing type?</FormHead>
          <RadioDefault
            name="billingType"
            layout={"vertical"}
            checked={billingType}
            data={[{ label: "Type1 (Based on working days)", value: 0 }, { label: "Type2 (Based on total of 160 hours)", value: 1 }]}
            handleChange={(e: any) => onChange(e, "billingType")}
          />
          {/* <Error>{error.paidLeave}</Error> */}
        </div>
        <div className="form-group">
          <div className={Styles.holidayWrapper}>
            <div className={Styles.holidayHeadWrapper}>
              <FormHead>Holiday List </FormHead><Icon icon="uil:file-import" onClick={() => setShowModal(true)}/>
            </div>
              <Table type='holidayList' data={props.holidayList} />
          </div>
        </div>        
        <div className="action-form">
          <Button variant="secondary" onClick={() => navigate('/companytimesheets')}> Back  </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}> Save  </Button>
        </div>
      </form>
      </div>
    </section>
    </>
  )
}

export default TimesheetSettings;
